import {EditorCommand, EditorModeType, Point} from "../../service/Editor";
import {commands} from "../../ApiUtils";

class EditorCommandFactory {
    startLine(point: Point, toolDiameter: number, editorMode: EditorModeType): EditorCommand {
        return {
            typeCode: commands.startLine.typeCode,
            args: {
                point1: point,
                point2: undefined,
                arg1: toolDiameter,
                arg2: editorMode,
                arg3: undefined,
                arg4: undefined
            }
        }
    }

    finishLine(): EditorCommand {
        return {
            typeCode: commands.finishLine.typeCode,
            args: {
                point1: undefined,
                point2: undefined,
                arg1: undefined,
                arg2: undefined,
                arg3: undefined,
                arg4: undefined
            }
        }
    }

    lineTo(point: Point): EditorCommand {
        return {
            typeCode: commands.lineTo.typeCode,
            args: {
                point1: point,
                point2: undefined,
                arg1: undefined,
                arg2: undefined,
                arg3: undefined,
                arg4: undefined
            }
        }
    }

    addHole(point: Point, diameter: number) {
        return {
            typeCode: commands.addHole.typeCode,
            args: {
                point1: point,
                point2: undefined,
                arg1: diameter,
                arg2: undefined,
                arg3: undefined,
                arg4: undefined
            }
        }
    }

    cancel() {
        return {
            typeCode: commands.cancel.typeCode,
            args: {
                point1: undefined,
                point2: undefined,
                arg1: undefined,
                arg2: undefined,
                arg3: undefined,
                arg4: undefined
            }
        }
    }

    unCancel() {
        return {
            typeCode: commands.unCancel.typeCode,
            args: {
                point1: undefined,
                point2: undefined,
                arg1: undefined,
                arg2: undefined,
                arg3: undefined,
                arg4: undefined
            }
        }
    }

    setZero(point: Point): EditorCommand {
        return {
            typeCode: commands.setZero.typeCode,
            args: {
                point1: point,
                point2: undefined,
                arg1: undefined,
                arg2: undefined,
                arg3: undefined,
                arg4: undefined
            }
        }
    }
}

export default new EditorCommandFactory()